import {User} from "@models/user.interface";
import {Card} from "@models/card.interface";

export const LOAD_USER = 'LOAD_USER';

export const EDIT_USER = 'EDIT_USER';
export const EDIT_USER_FAIL = 'EDIT_USER_FAIL';

export const LOAD_USER_CARDS = 'LOAD_USER_CARDS';
export const LOAD_USER_CARDS_SUCCESS = 'LOAD_USER_CARDS_SUCCESS';

export const REMOVE_PROFILE = 'REMOVE_PROFILE';

export class LoadUser {
  readonly type = LOAD_USER;
  constructor(public payload: {user: User}) {}
}

export class RemoveProfile {
  readonly type = REMOVE_PROFILE;
}

export class LoadUserCards {
  readonly type = LOAD_USER_CARDS;
}

export class LoadUserCardsSuccess {
  readonly type = LOAD_USER_CARDS_SUCCESS;
  constructor(public payload: {cards: Card[]}) {}
}


export class EditUser {
  readonly type = EDIT_USER;
  constructor(public payload: any) {}
}

export class EditUserFail {
  readonly type = EDIT_USER_FAIL;
}



// WEBPACK FOOTER //
// ./src/app/store/actions/profile.action.ts